export default {
    Form: {
        Title: 'Boltt平台注册中心',
        SignIn: '注册',
        Verification: '审核',
        Active: '激活',
        Email: '邮箱',
        EmailOrPhone: '邮箱/手机号',
        Captcha: '验证码',

        China: "中国",
        NonChina: "非中国",
        GetSmsCaptcha: '获取短信验证码', //获取短信验证码
        Reacquire: '重新获取', //重新获取
        SubmitSuccess: '提交成功', //提交成功

        ActiveAccount: '账号激活', //账号激活
        RetrievePassword: '密码找回', //密码找回
        ResetPassword: '重置密码', //重置密码
        ResetSuccessTips: '新密码设置成功，请牢记您的新密码', //新密码设置成功，请牢记您的新密码
        SmsBack: '手机验证码找回', //手机验证码找回
        EmailBack: '邮箱找回', //邮箱找回
        VerifyEmail: '验证邮件已经发送成功',
        VerifyTipsContentNote: '若未收到验证邮件，建议您到邮件垃圾箱找找看，或点此',

        Verify: '验证', //验证 verification
        Reset: '重置', // 重置
        Complete: '完成', //完成
        Second: '秒', //秒
    },
    Button: {
        SignIn: '注 册',
        Next: '下一步',
        Previous: '上一步',
        ToLogin: '去登录',
        GotIt: '知道了',
        Retry: '重试',
    },
    Placeholder: {
        EnterEmail: '常用邮箱',
        EnterNewPassword: '请输入新密码', // 请输入新密码
        EnterConfirmPassword: '确认密码', // 确认密码
        EnterPassword: '请输入密码', // 输入密码
        EnterCaptcha: '请输入验证码', //密码找回-输入验证码
        EnterCompanyName: '*公司中文名', // 公司名称
        EnterCompanyNameEN: '*公司英文名', // 公司英文名
        DepartmentName: '*所属部门名称',
        PositionName: '*您的职位', //职位
        Uname: '*您的姓名', //姓名
        RefereeName: '推荐您使用的我司商务姓名', //推荐您使用的我司商务姓名
        EnterNote: '备注', // 备注
        Country: '*请选择国家',  //请选择国家
        Region: '*请选择区域',  //请选择区域
        YourPhoneNumber: '*您的手机号', // 联系人手机号
        EnterImgCaptcha: '*输入图形验证码', // 输入图形验证码
        EnterSmsCaptcha: '*输入短信验证码', // 输入短信验证码
        EnterConfirmNewPassword: '再一次输入密码', //确认新密码
        EnterPhoneNumber: '请输入手机号', //请输入手机号
        PleaseEnterSmsCaptcha: '请输入短信验证码', //请输入短信验证码
    },
    Validate: {
        Email: {
            // 邮箱/账号
            IsNull: '请输入邮箱',
            IsCorrect: '请输入正确的Email地址',
            IsRegistered: '该邮箱已被注册，请直接登录',
            IsExists: '该邮箱已被注册，请您联系管理员确认',
            IsUnregistered: '邮箱未注册',
        },
        Password: {
            // 注册登录 => 密码
            IsNull: '请输入密码',
            IsCorrect: '密码长度在6-20之间，支持数字、字母、标点符号，不包含空格，至少包含其中两种',
        },
        NewPassword: {
            // 修改密码 => 新密码
            IsNull: '请输入新密码',
            IsCorrect: '密码长度在6-20之间，支持数字、字母、标点符号，不包含空格，至少包含其中两种',
        },
        ConfirmPassword: {
            // 确认密码
            IsNull: '请再一次输入密码',
            NotSame: '两次密码输入不一致',
        },
        CompanyNameZh: {
            // 公司中文名
            IsNull: '请输入公司中文名',
        },
        CompanyNameEn: {
            // 公司英文名
            IsNull: '请输入公司英文名',
            IsCorrect: '仅支持英文字母、数字、逗号、点、下划线、横线、空格',
        },
        Region: {
            // 所在区域
            IsNull: '请选择您所在区域',
            CountryIsNull: '请选择国家',
        },
        Phone: {
            // 手机号
            IsNull: '请输入您的手机号码',
            PhoneNumber: '请输入11位且有效的手机号码',
            IsRegistered: '该手机号已被注册，请直接登录',
            IsExists: '该手机号已被注册，请您联系管理员确认',
        },
        Remark: {
            // 备注
            IsNull: '请输入备注',
        },
        DepartmentName: {
            // 部门
            IsNull: '请输入所属部门名称',
        },
        PositionName: {
            // 职位
            IsNull: '请输入您的职位',
        },
        Name: {
            // 名称
            IsNull: '请输入您的名称',
        },
        RefereeName: {
            // 推荐人
            IsNull: '请输入您的推荐人名',
        },
        Captcha: {
            // 图形验证码
            IsNull: '请输入图形验证码',
            IsError: '请输入正确的图形验证码',
        },
        SmsCaptcha: {
            // 短信验证码
            IsNull: '请输入短信验证码',
            IsError: '短信验证码不正确',
            minLength: '验证码不得少于6个字符',
        },
        StringLength: {
            // 字符串长度
            Length200: '长度在200个字符以内',
            Length100: '长度在100个字符以内',
            Length20: '长度在20个字符以内',
        },
    },
    Message: {
        SendSuccess: '短信验证码已发送至手机，请注意查看',
        NotPhone: '请先输入手机号', //请先输入手机号
        DefaultSuccess: '操作成功', // 操作成功
        DefaultError: '操作失败', // 操作失败
        VerifiySuccess: '验证成功', // 验证成功
        ResetSuccess: '重置成功', // 重置成功
        ActivationFails: '激活失败', //激活失败

        MsgCode201: '添加成功', //添加成功
        MsgCode202: '修改成功', // 修改成功
        MsgCode203: '删除成功', // 删除成功
        MsgCode204: '添加失败', //添加失败
        MsgCode205: '修改失败', //修改失败
        MsgCode206: '删除失败', //删除失败

        MsgCode1: '用户账号已冻结', //用户账号已冻结
        MsgCode2: '用户账号待审核', // 用户账号待审核
        MsgCode3: '用户账号待激活', // 用户账号待激活
        MsgCode4: '用户账号审核不通过', //用户账号审核不通过
        MsgCode5: '用户账号密码错误', //用户账号密码错误
        MsgCode6: '用户账号不存在', //用户账号不存在
        MsgCode7: '冻结失败',
        MsgCode8: '冻结成功',
        MsgCode9: '解冻失败',
        MsgCode10: '解冻成功',
        MsgCode11: '角色分配失败',
        MsgCode12: '角色分配成功',
        MsgCode13: '注册失败',
        MsgCode14: '注册成功',
        MsgCode15: '邮箱已被占用',
        MsgCode16: '邮箱未注册',
        MsgCode17: '邮箱未激活',
        MsgCode18: '链接已失效',
        MsgCode19: '找回密码失败',
        MsgCode20: '找回密码成功',
        MsgCode21: '添加角色失败',
        MsgCode22: '添加失败,角色名称不能相同！',
        MsgCode23: '分配权限失败',
        MsgCode24: '分配权限成功',
        MsgCode25: '审核失败',
        MsgCode26: '激活邮件发送失败',
        MsgCode27: '激活邮件发送成功',
        MsgCode28: '图片验证码不正确',
        MsgCode29: '找回密码激活邮件发送失败',
        MsgCode30: '找回密码激活邮件发送成功',
        MsgCode31: '邮件发送失败',
        MsgCode32: '审核不通过，邮件发送未成功',
        MsgCode33: '审核不通过，邮件发送成功',
        MsgCode34: '差分有效期更新失败',
        MsgCode35: '删除项目和用户权限失败',
        MsgCode36: '删除项目和用户权限成功',
        MsgCode37: '删除失败，至少保留一个项目关联',
        MsgCode38: '修改项目和用户权限失败',
        MsgCode39: '修改项目和用户权限成功',
        MsgCode40: '添加项目和用户权限失败',
        MsgCode41: '添加项目和用户权限成功',
        MsgCode42: '子账户重置密码失败，重置密码不能与原密码一样',
        MsgCode43: '该邮箱已占用',
        MsgCode44: '子账户添加失败,不能超过100个',
        MsgCode45: '子账户添加成功，激活邮件发送失败',
        MsgCode46: '子账户添加失败',
        MsgCode47: '子账户重新发送激活邮件失败',
        MsgCode48: '差分有效期更新成功',
        MsgCode49: '激活失败，请重新注册',
        MsgCode50: '激活成功',
        MsgCode51: '修改密码失败，新老密码一致',
        MsgCode52: '修改密码失败，原密码错误',
        MsgCode53: '账号激活失败，账户不存在',
        MsgCode54: '错误的邮箱不能发送激活邮件',
        MsgCode550: '今日获取验证码次数已达上限，请明日重试',
        MsgCode551: '短信验证码错误（或已失效），请重新输入（或重新获取）',
        MsgCode552: '短信验证码已超时',
        MsgCode553: '短信发送失败',
        MsgCode547: '手机号已被占用',
        MsgCode548: '请输入11位且有效的手机号码',
        MsgCode559: '不存在绑定该手机号的用户',
        MsgCode100001: '系统异常，请稍后重试',
        MsgCode100002: '系统异常，请稍后重试',
        MsgCode535: '用户账号已冻结', //用户账号已冻结
    },

    /* 提交成功页面提示信息 */
    SubmitSuccessPageInfo: {
        title: '提交成功', // dialog 标题
        main: '账户审核中, 我司工作人员将在1-2个工作日内审核您的注册信息, 届时您的邮箱将收到激活邮件或审核不通过邮件。', // 主要内容
        tips: {
            // 提示
            title: '温馨提示:',
            data: [
                { msg: '因不同邮箱服务器安全设置原因, 激活邮件可能被服务器误判为垃圾邮件。' },
                {
                    msg: '若2个工作日后仍未收到邮件, 请尝试以下解决方法:',
                    children: ['<div><span class="eyes-on">重新填写</span>注册信息</div>', '<div>联系邮箱: care@boltt.com | 联系电话:022-69089822</div>'],
                },
                { msg: '工作时间: 星期一至星期五, 9:30am-18:00pm' },
            ],
        },
    }
}
